<template>
  <div v-if="!loading">
    <Navbar :toClose="toClose" />

    <section class="section" v-if="!loading">
      <router-view v-slot="{ Component }" :key=$route.path>
        <transition name="fade" mode="out-in">
          <component :is="Component" @updateToClose="checkOpenOperations" />
        </transition>
      </router-view>
    </section>

    <section class="section" v-if="loading">
      <div class="container has-text-centered">
        Caricamento...
      </div>
    </section>

  </div>
</template>

<script>
import Navbar from "./components/Navbar"

import utils from './utils'

export default {
  components: {
    Navbar: Navbar,
  },

  data() {
    return {
      loading: true,
      toClose: 0,
      savingDrafts: false
    }
  },

  methods: {
    getSettings() {
      const self = this

      this.$http.get('/setting')
      .then(function (response) {
        if (response.data) {
          self.$store.commit('setSettings', response.data)
        }
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    getAllUsers() {
      const self = this

      this.$http.get('/user')
        .then(function (response) {
          if (response.data) {
            self.$store.commit('setAllUsers', response.data)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    saveDrafts() {
      if (this.savingDrafts) {
        return
      }

      const drafts = utils.getDrafts()

      const filtered = drafts.filter(d => (!d._id || d.value._edited))

      if (filtered.length) {
        this.savingDrafts = true

        this.$http.post('/draft', {drafts: filtered})
          .then(function (response) {
            utils.saveDrafts(drafts.filter(d => d._id && !d.value._edited).concat(response.data))
          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(() => {
            this.savingDrafts = false
          })
      }
    },

    checkOpenOperations() {
      if (this.$store.getters.amOperator) {
        const self = this

        const date = new Date()

        date.setDate(date.getDate() - 1)
        const endDate = date.toDateInputValue()

        date.setDate(date.getDate() - 6)
        const startDate = date.toDateInputValue()
        
        const operator = this.$store.state.user._id

        this.$http.get('/operation', {params: {startDate, endDate, operator, noStatus: true, size: 50}})
          .then(function (response) {
            self.toClose = response?.data?.totalRecords
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    }
  },

  mounted() {
    const self = this

    this.$http.get('/user/check')
      .then(function (response) {
        self.$store.commit('setUser', response.data)

        self.getSettings()

        self.getAllUsers()

        self.checkOpenOperations()

        setTimeout(() => {
          self.loading = false
        }, 250)
      })
      .catch(function (error) {
        self.$store.commit('setUser', false)
        self.$router.push('/login')
        
        setTimeout(() => {
          self.loading = false
        }, 250)
      })
      
      setInterval(function () {
        const drafts = utils.getDrafts()
        if (Array.isArray(drafts) && drafts.length) {
          self.saveDrafts()
        }
      }, 10 * 1000)
  }
}
</script>